import { render } from "./Selections.vue?vue&type=template&id=325fd77b"
import script from "./Selections.vue?vue&type=script&lang=js"
export * from "./Selections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__